// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { AfterViewInit, Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppEvent } from '@interfaces/interfaces';
import { User } from '@interfaces/user.interfaces';

@Component({
    selector: 'app-change-signature-modal',
    templateUrl: './change-signature-modal.component.html',
    styleUrls: ['./change-signature-modal.component.scss'],
})
export class ChangeSignatureModalComponent implements AfterViewInit {
    @Input() user: User;

    public canEditSignatures = false;

    constructor(
        private dialogRef: MatDialogRef<ChangeSignatureModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.user = data.user;

        setTimeout(() => {
            const el = document.querySelector('#signature-title');
            el.scrollIntoView(true);
        }, 50);
    }

    ngAfterViewInit(): void {
        // Need to give the view time to load the canvas, so we
        // can resize properly
        setTimeout(() => (this.canEditSignatures = true), 100);
    }

    public eventHandler(event: AppEvent): void {
        switch (event.context) {
            case 'close':
                this.dialogRef.close();
                break;
            case 'changed-values':
                this.dialogRef.close(event.data);
                break;
            default:
                break;
        }
    }

    public close() {
        this.dialogRef.close();
    }
}
